import React from 'react'
import Navbar from '../Navbar'
import { Link, NavLink } from "react-router-dom";
import Lottie from "lottie-react";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
    AccordionItemState,
} from 'react-accessible-accordion';
import Footer from '../Footer';
import BannerBg from "../../img/conversionBG.avif";
import WhyBg from "../../img/vitualCardBG.png";
import { FiMinus } from "react-icons/fi";
import { FiPlus } from "react-icons/fi";
import DownloadAfriPay from "../DownloadAfriPay";
import animationData from "../../animations/virtualCardAnimation.json";
import { SEO } from '../SEO';
import { FaAngleDown, FaAngleUp, FaRegArrowAltCircleRight } from 'react-icons/fa';
import { motion } from "framer-motion";
import HeroCTA1 from '../HeroCTA1';
import HeroCTA2 from '../HeroCTA2';
import { useDownloadAppModal } from '../../context/DownloadAppModalContext';

const slideInLeft = {
    hidden: { opacity: 0, x: -80 },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.8,
            ease: "easeOut",
        },
    },
};

const slideInRight = {
    hidden: { opacity: 0, x: 80 },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.8,
            ease: "easeOut",
        },
    },
};

const container = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.2,
        },
    },
};

const fadeUp = {
    hidden: {
        opacity: 0,
        y: 40,
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: "easeOut",
        },
    },
};

const fadeUpImage = {
    hidden: { opacity: 0, y: 40, scale: 0.96 },
    visible: {
        opacity: 1,
        y: 0,
        scale: 1,
        transition: { duration: 0.7, ease: "easeOut" },
    },
};

function VitualCardPageV3() {
    const { openDownloadModal } = useDownloadAppModal();

    return (
        <>

            <SEO
                title="Virtual Card | Afripay"
                description="Get Virtual cards to shop globally on Afripay."
                canonical="https://goafripay.com/virtual-card-page"
            />

            <Navbar />



            {/* Hero Section */}
            <section className='bg-white max-w-7xl mx-auto md:pt-[180px]'>
                <motion.div
                    variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}
                    style={{
                        backgroundImage: `url(${BannerBg})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                    }}
                    className='flex flex-col lg:flex-row items-center justify-between rounded-3xl py-24 lg:py-12 px-10 lg:h-[430px]'
                >
                    <motion.div variants={slideInLeft} className='max-w-[300px] md:max-w-[512px] text-center lg:text-left mb-2 lg:mb-0'>
                        <h1 className='text-white text-2xl md:text-[50px] font-display-fran font-bold mb-6 md:leading-[60px]'>Digital Card for your Digital Life...</h1>
                        <p className='text-white text-base md:text-lg mb-11'>Shop online, pay tuition, subscribe to international platforms, and enjoy higher limits all powered by AfriPay’s secure USD card.</p>
                        <button className="w-32 h-13 p-3.5 text-sm text-white bg-[#0B7F47] border-2 border-[#7FBC51] rounded-xl w-36" onClick={openDownloadModal}>Get started now!</button>
                    </motion.div>
                    <motion.img variants={slideInRight} animate={{ rotate: [14, -14, 14] }} transition={{ duration: 2, ease: "easeInOut", repeat: Infinity }} src="/images/virtualCard.avif" alt="Virtual Card" width={520} />
                </motion.div>
            </section>


            {/* One Account, Global Power */}
            <div className="bg-[#FFFCEA] py-16 px-4 text-center">
                <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} className='max-w-7xl mx-auto'>
                    <motion.h2 variants={fadeUp} className='text-3xl text-[#030319] font-display-fran font-bold'>Where you can use it</motion.h2>
                    <motion.p variants={fadeUp} className='text-lg text-[#344054] mb-6'>Accepted everywhere Visa is accepted</motion.p>
                    <div className='grid grid-cols-1 md:grid-cols-4 lg:grid-cols-5 gap-4 justify-items-center'>
                        {[
                            { icon: "💡", title: "Pay Bills", text: "Electricity, Water, Cable TV", link: "/bills-payment" },
                            { icon: "🎓", title: "Tuiton Payment", text: "School and course fees", link: "/tuition-payment" },
                            { icon: "✈", title: "Travel", text: "Booking.com, Airbnb", link: "/book-flight" },
                            { icon: "🛡️", title: "Secure Assets", text: "Car and House Insurance", link: "/health-travel-insurance" },
                            { icon: "🪙", title: "Earn Rewards", text: "Afripay Coin rewards as you spend", link: "/afripay-coin-page" },
                            { icon: "📚", title: "Acquire Loans", text: "Acquire study loans using Afripay", link: "/student-loan" },
                            { icon: "💻", title: "Build Payments", text: "For Freelancers  and Developers", link: "/freelancers" },
                            { icon: "👨‍🎓", title: "Student Purchases", text: "Manage student expenses", link: "/students" },
                        ].map((item, i) => (
                            <motion.a
                                href={item.link}
                                key={i}
                                variants={fadeUpImage}
                                className='w-[212px] h-[155px] p-6 rounded-xl bg-[#FFF/10] shadow-md transition-all duration-300 cursor-pointer hover:bg-[#D5EAC9]'
                            >
                                <span className='text-4xl mb-3'>{item.icon}</span>
                                <h1 className='text-[#101828] font-semibold text-lg mb-2'>{item.title}</h1>
                                <p className='text-[#4A5565] text-sm font-normal'>{item.text}</p>
                            </motion.a>
                        ))}
                    </div>
                </motion.div>
            </div>

            <motion.section
                className="bg-white max-w-7xl mx-auto py-16 text-center"
                variants={container}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
            >
                <motion.h2
                    variants={fadeUp}
                    className="text-3xl text-[#030319] font-display-fran font-bold mb-3"
                >
                    One Account, Global Power
                </motion.h2>

                <motion.p
                    variants={fadeUp}
                    className="text-lg text-[#344054] mb-12"
                >
                    Everything you need to manage your global transactions in one place
                </motion.p>

                <div
                    className="w-full grid grid-cols-1 md:grid-cols-3 gap-5"
                >
                    {[
                        { src: "/images/global_access.avif", alt: "Global Access" },
                        { src: "/images/real_time.avif", alt: "Real Time Control" },
                        { src: "/images/instant_card.avif", alt: "Instant Card Creation" },
                    ].map((item, i) => (
                        <motion.img
                            key={i}
                            src={item.src}
                            alt={item.alt}
                            variants={fadeUpImage}
                        />
                    ))}
                </div>
            </motion.section>

            <section className='max-w-7xl mx-auto'>
                <img src="/images/why_virtual_card.avif" alt="Why Afripay Virtual Card" className='hidden md:block md:w-full lg:max-w-7xl' />
                <img src="/images/why_virtual_card_mobile.avif" alt="Why Afripay Virtual Card" className='w-full block md:hidden' />
            </section>

            {/* FAQ SECTION */}
            <section className="w-full px-4 pt-10 md:pt-20 pb-10">
                <div className="max-w-7xl mx-auto">
                    <div className="w-full flex items-end justify-between mb-8 font-display-fran">
                        <div className="flex flex-col text-left gap-3">
                            <h2 className="text-2xl sm:text-2xl lg:text-4xl text-[#030319] font-display font-bold">
                                Everything You Need to Know
                            </h2>
                            <p className="text-[#344054] text-lg">Discover how AfriPay works and what makes us different</p>
                        </div>
                        <Link to={'/faq'} className="text-[#024529] flex items-center justify-center gap-1.5 cursor-pointer transition-all duration-300 hover:text-gray-600">
                            View All <FaRegArrowAltCircleRight />
                        </Link>
                    </div>
                    <div className="gap-8 lg:mt-16 mt-8 ">
                        <div className="lg:col-span-8 col-span-12">
                            <Accordion allowZeroExpanded allowMultipleExpanded>
                                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                                    <AccordionItemHeading>
                                        <AccordionItemState>
                                            {({ expanded }) => (
                                                <AccordionItemButton
                                                    className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                                                    aria-expanded={expanded}
                                                >
                                                    <span>What is AfriPay?</span>
                                                    <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                                                        {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                                                    </span>
                                                </AccordionItemButton>
                                            )}
                                        </AccordionItemState>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                                        <p className="w-[940px]">
                                            AfriPay is an innovative platform simplifying
                                            international tuition payments, securing educational
                                            loans, and offering a digital wallet feature for
                                            seamless financial transactions.
                                        </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                                    <AccordionItemHeading>
                                        <AccordionItemState>
                                            {({ expanded }) => (
                                                <AccordionItemButton
                                                    className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                                                    aria-expanded={expanded}
                                                >
                                                    <span>How does AfriPay simplify tuition payments?</span>
                                                    <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                                                        {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                                                    </span>
                                                </AccordionItemButton>
                                            )}
                                        </AccordionItemState>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                                        <p className="w-[940px]">
                                            AfriPay streamlines the tuition payment process, providing a user-friendly interface and multiple payment options for efficient and secure transactions.
                                        </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                                    <AccordionItemHeading>
                                        <AccordionItemState>
                                            {({ expanded }) => (
                                                <AccordionItemButton
                                                    className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                                                    aria-expanded={expanded}
                                                >
                                                    <span>What security measures does AfriPay have in place?</span>
                                                    <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                                                        {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                                                    </span>
                                                </AccordionItemButton>
                                            )}
                                        </AccordionItemState>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                                        <p className="w-[940px]">
                                            AfriPay employs cutting-edge encryption technologies to ensure the security and confidentiality of user data, providing a safe environment for financial transactions.
                                        </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                                    <AccordionItemHeading>
                                        <AccordionItemState>
                                            {({ expanded }) => (
                                                <AccordionItemButton
                                                    className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                                                    aria-expanded={expanded}
                                                >
                                                    <span>What is the digital wallet feature in AfriPay?</span>
                                                    <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                                                        {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                                                    </span>
                                                </AccordionItemButton>
                                            )}
                                        </AccordionItemState>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                                        <p className="w-[940px]">
                                            The digital wallet feature allows users to conveniently manage and access funds, enabling cashless transactions, budgeting, and automated savings.
                                        </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                                    <AccordionItemHeading>
                                        <AccordionItemState>
                                            {({ expanded }) => (
                                                <AccordionItemButton
                                                    className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                                                    aria-expanded={expanded}
                                                >
                                                    <span>How does AfriPay support educational loans?</span>
                                                    <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                                                        {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                                                    </span>
                                                </AccordionItemButton>
                                            )}
                                        </AccordionItemState>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                                        <p className="w-[940px]">
                                            AfriPay assists users in securing educational loans, streamlining the application process, and providing transparent terms for quick approvals.
                                        </p>
                                    </AccordionItemPanel>
                                </AccordionItem>

                            </Accordion>

                        </div>
                    </div>
                    <div className="w-full flex justify-center pt-5">
                        <button type="button" onClick={openDownloadModal} className="w-[174px] h-13 rounded-lg bg-[#0B7F47] border-2 border-[#7FBC51] shadow-sm text-white text-sm p-3.5 cursor-pointer transition-colors duration-300 hover:bg-[#0B7F47]/60">Get started — it's free</button>
                    </div>
                </div>
            </section>

            <motion.section variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} className="max-w-7xl mx-auto flex flex-col items-center pt-20 pb-4">
                <motion.h2 variants={fadeUp} className="text-[#030319] text-3xl font-bold font-display-fran mb-3">Transparent Fee Structure</motion.h2>
                <motion.p variants={fadeUp} className="text-[#344054] text-2xl mb-4">No hidden Charges. Know exactly what you pay</motion.p>
                <motion.div variants={fadeUpImage}>
                    <img src="/images/card_fee_structure.avif" alt="Fee Structure" width={961} className='hidden md:block' />
                    <img src="/images/card_fee_structure_mobile.avif" alt="Fee Structure" className='w-full block md:hidden' />
                </motion.div>
            </motion.section>

            <div className='max-w-7xl mx-auto mb-4 lg:mb-8'>
                <HeroCTA1 />
                <HeroCTA2 />
            </div>

            {/* Download AfriPay App */}
            <DownloadAfriPay />

            {/* <-- Footer --> */}
            <Footer />

        </>
    )
}

export default VitualCardPageV3